import { render, staticRenderFns } from "./MetaNav.vue?vue&type=template&id=49dbb8a2&scoped=true&"
import script from "./MetaNav.vue?vue&type=script&lang=js&"
export * from "./MetaNav.vue?vue&type=script&lang=js&"
import style0 from "./MetaNav.vue?vue&type=style&index=0&id=49dbb8a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dbb8a2",
  null
  
)

export default component.exports